<template>
  <div>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" @click="$router.push('/admon')" style="cursor: pointer">Administración</li>
            <li class="breadcrumb-item active" aria-current="page">Ajuste de Saldos</li>
        </ol>
    </nav> 
    <div class="container-fluid">
      <vx-card title="Ajuste y monitoreo de saldos">
          <div class="skinny row">
            <div class="col-md-12 mb-3">
                <div class="flex flex-wrap">
                    <vs-icon icon="info" size="small" color="red"></vs-icon>
                    <label class="mt-1 ml-2">El ajuste y monitoreo de saldos solo esta permitido sobre el mes en curso <strong>Debes indicar una fecha</strong>.</label>
                </div>
            </div>
            <div class="col-md-2">
                <vs-select
                  placeholder="Seleccione"
                  label="Tipo de usuario"
                  class="w-full"
                  v-model="type"
                  >
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in type_options" />
                </vs-select>
            </div>
            <div class="col-md-2">
              <label>ID's. <small>(Presiona enter para agregar)</small></label>
              <vs-input type="number" class="w-full" icon-pack="feather" icon="icon-user" placeholder="Escribe un ID..." v-model="id" @keyup.enter="addId()" />
            </div>
            <!-- <div class="col-md-2">
              <label for class="vs-input--label">Seleciona</label>
              <vs-checkbox class="mt-3" v-model="useDate">¿A partir de una fecha?</vs-checkbox>
            </div> -->
            <div class="col-md-2">
              <label for class="vs-input--label">Fecha</label>
              <datepicker
                v-if="user.user_id == 1864 || user.user_id == 11838"
                placeholder="Fecha"
                :language="es"
                v-model="startDate"
                format="dd/MM/yyyy"
                :disabled="!useDate"
              />
              <datepicker
                v-else
                placeholder="Fecha"
                :language="es"
                v-model="startDate"
                format="dd/MM/yyyy"
                :disabled="!useDate"
                :disabledDates="{ to: new Date(firstDayOfMonth) }"
              />
            </div>
            <div class="col-md-4">
              <small class="bold">(La fecha influye en las acciones de Ajustar y Monitor)</small>
              <div class="flex flex-wrap">
                <vs-button color="dark" @click="getBalances()" :disabled="ids.length <= 0">Consultar</vs-button>
                <vs-button class="ml-3" color="#388E3C" @click="fixBalances()" :disabled="ids.length <= 0">Ajustar</vs-button>
                <vs-button class="ml-3" color="#009688" @click="runMonitor()" :disabled="ids.length <= 0">Correr monitor</vs-button>
              </div>
            </div>
          </div>
          <br>
          <div class="skinny row">
            <div class="col-md-4">
              <vs-table
                ref="idsTable"
                class="mt-5"
                :data="idsOrderer"
                noDataText="No hay datos ingresados"
              >
                <template slot="header">
                  <h5>
                    Ajustar {{ids.length}} {{(type == 'i' ? 'inversionistas' : 'solicitantes')}}:
                  </h5>
                </template>
                <template slot="thead">
                  <vs-th class="bold">{{(type == 'i' ? 'Id inversionista' : 'Id solicitante')}}</vs-th>
                  <vs-th>Eliminar</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td>{{ tr }}</vs-td>
                    <vs-td>
                      <vs-button size="small" radius color="danger" icon-pack="feather" icon="icon-trash" @click="removeId(tr)"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
            <div class="col-md-4">
              <vs-table
                v-if="before.length > 0"
                ref="currentBalancesTable"
                class="mt-5"
                :data="before"
                noDataText="No hay datos disponibles"
              >
                <template slot="header">
                  <h5>
                    Saldos actuales:
                  </h5>
                </template>
                <template slot="thead">
                  <vs-th class="bold">{{(type == 'i' ? 'Id inversionista' : 'Id solicitante')}}</vs-th>
                  <vs-th class="bold">Balance actual</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td><label class="mt-1">{{(type == 'i' ? tr.investor_id : tr.client_id)}}</label></vs-td>
                    <vs-td><small class="pill-dark">${{formatPrice(tr.final_balance)}}</small></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
            <div class="col-md-4">
              <vs-table
                v-if="after.length > 0"
                ref="newBalancesTable"
                class="mt-5"
                :data="after"
                noDataText="No hay datos disponibles"
              >
                <template slot="header">
                  <h5>
                    Saldos ajustados:
                  </h5>
                </template>
                <template slot="thead">
                  <vs-th class="bold">{{(type == 'i' ? 'Id inversionista' : 'Id solicitante')}}</vs-th>
                  <vs-th class="bold">Balance actual</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td><label class="mt-1">{{tr.id}}</label></vs-td>
                    <vs-td><small class="pill-success">${{formatPrice(tr.current_balance)}}</small></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
      </vx-card>
      <br>
      <vx-card title="Resultados del monitor de saldos:">
          <div class="skinny row">
            <div class="col-md-12">
              <vs-table
                ref="idsTable"
                class="mt-5"
                stripe
                :data="balancesMonitor"
                noDataText="No hay datos disponibles"
              >
                <template slot="thead">
                  <vs-th class="bold">{{(type == 'i' ? 'Id inversionista' : 'Id solicitante')}}</vs-th>
                  <vs-th>Saldo actual</vs-th>
                  <vs-th>Saldo esperado</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td><small class="pill-dark">${{formatPrice(tr.current_balance)}}</small></vs-td>
                    <vs-td><small :class="(tr.current_balance == tr.monitor_balance ? 'pill-success' : 'pill-danger')">${{formatPrice(tr.monitor_balance)}}</small></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
      </vx-card>
    </div>
  </div>
</template>

<script lang="js">
  import {formatPrice, formatMoney} from '../../../components/admin/filters.js';
  import Toasted from 'vue-toasted';
  import Datepicker from "vuejs-datepicker";
  import { es } from "vuejs-datepicker/dist/locale";
  export default  {
    name: 'fix-balances',
    props: [],
    components: {
      Datepicker,
    },
    data() {
      return {
        es: es,
        startDate: new Date(new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()),
        useDate: true,
        firstDayOfMonth: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        ids: [],
        type:'i',
        type_options:[
          {text:'Inversionista',value:'i'},
          {text:'Solicitante',value:'a'}
        ],
        id: '',
        before: [],
        after:[],
        balancesMonitor: []
      }
    },
    computed:{
      idsOrderer: function() {
        return this.ids.sort(function (a, b) {
            return a - b;
        });
      },
    },
    watch: {
      type: function (val) {
        this.before = []
        this.after = []
      }
    },
    methods: {
      formatPrice,
      addId(){
        if(this.id != ''){
          if (!this.ids.includes(this.id)) {
            this.ids.push(this.id);
            this.id ='';
          }
        }        
      },
      async fixBalances(){
        this.after = [];
        this.balancesMonitor=[];
        this.showLoading(true); 
         try{
          var response = await axios.post('/api/fix-balances', {
            ids: this.ids,
            type: this.type,
            useDate: this.useDate,
            date: this.startDate
          });
          this.after = response.data;
          this.successNotif("Aviso", 'Saldos ajustados.', 4000);
        }catch(e){
          if(e.response != undefined && e.response.data != undefined && e.response.data.message != undefined){  
            this.errorNotif("Aviso", e.response.data.message, 4000);          
          }else{
            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
          }
        }
        this.showLoading(false); 
      },
      async getBalances(){
        this.before=[];
        this.showLoading(true);
        try{
          var response = await axios.post('/api/check-balances', {
            ids: this.ids,
            type: this.type
          });
          this.before = response.data
        }catch(e){
          if(e.response != undefined && e.response.data != undefined && e.response.data.message != undefined){ 
            this.errorNotif("Aviso", e.response.data.message, 4000);           
          }else{
            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
          }
        }
        this.showLoading(false);
      },
      removeId(id){
        var filtered = []
        for(var i = 0; i < this.ids.length; i++){
          if(this.ids[i] != id){
            filtered.push(this.ids[i])
          }
        }
        this.ids = filtered
      },
      async runMonitor(){
        this.balancesMonitor=[];
        this.showLoading(true); 
        try{
          var response = await axios.post('/api/run-balances-monitor', {
            ids: this.ids,
            type: this.type,
            useDate: this.useDate,
            date: this.startDate
          });
          this.balancesMonitor = response.data;
        }catch(e){
          if(e.response !== undefined && e.response.data !== undefined && e.response.data.message !== undefined){   
            this.errorNotif("Aviso", e.response.data.message, 4000);         
          }else{
            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
          }
        }
        this.showLoading(false); 
      },
    }
}
</script>
